// @ts-nocheck
import { CALENDAR_ENTRY_GROUP, ENTRY_BY_TYPE } from '@/calendar-types'
import { calendarEndpoints } from '@/utils/endpoints'
import { parseISOWithoutTimezone, stripHtml } from '@/utils/parsers'
import { match, P } from 'ts-pattern'

async function sendMixPanelEvent(
  event: string,
  event_data: {
    [key: string]: any
  },
) {
  const deviceInfo = localStorage.getItem('device_info')
  const deviceToken = localStorage.getItem('device-token')

  const authStore = useAuthStore()
  const appStore = useAppStore()

  if (appStore.isAdmin) return

  event_data.spot_id = authStore.spotId

  useApi(calendarEndpoints().calendarMixPanel(authStore.spotId)).post({
    event,
    event_data: {
      ...event_data,
      device: deviceInfo?.length ? deviceInfo : undefined,
      device_token: deviceToken?.length ? deviceToken : undefined,
    },
  })
}

function getMixpanelEntryType(entry: ENTRY_BY_TYPE[keyof ENTRY_BY_TYPE]) {
  if ('variant' in entry && entry.variant === 'reel') {
    return `${entry.type}_reel`
  } else if ('variant' in entry && entry.variant === 'story') {
    return `${entry.type}_story`
  }
  return entry.type
}

export function sendViewedCalendarPageEvent() {
  const event_data = {
    page_name: 'Calendar',
  }
  sendMixPanelEvent('Viewed Admin Page', event_data)
}

export async function sendCalendarEntryPreviewEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    status: calendarStore?.selectedEntry?.status,
    has_image: calendarStore?.selectedEntry?.image_url ? true : false,
    campaign_reason: calendarStore?.selectedEntry?.campaign_reason,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    ...calendarStore.selectedEntry?.tracking_properties,
  }

  sendMixPanelEvent('Calendar Entry Preview', event_data)
}

export async function sendClickedCalendarEntryPreviewEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),

    campaign_reason: calendarStore?.selectedEntry?.campaign_reason,
    date_and_time: format(
      parseISOWithoutTimezone(calendarStore?.selectedEntry!.interval[0]),
      'MMMM do yyyy - h:mm a',
    ),
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Clicked on Calendar Entry Preview', event_data)
}

export async function sendShownSuggestedEntryEvent(
  entry: ENTRY_BY_TYPE['content_nudge'],
) {
  const event_data = {
    suggested_date: format(
      parseISOWithoutTimezone(entry.interval[0]),
      'MMMM do yyyy',
    ),
    suggested_day: format(parseISOWithoutTimezone(entry.interval[0]), 'E'),
    suggested_hour: format(
      parseISOWithoutTimezone(entry.interval[0]),
      'h:mm a',
    ),
    suggested_type: entry.variant,
  }

  sendMixPanelEvent('Shown Suggested Entry', event_data)
}

export async function sendClickedOnMultipleEntriesEvent(
  entryGroup: CALENDAR_ENTRY_GROUP,
) {
  const event_data = {
    name: 'Clicked on Multiple Entries',
    data: {
      entry_type: entryGroup.type,
      num_of_entries: entryGroup.items.length,
      date_and_time: format(
        parseISOWithoutTimezone(entryGroup.items[0].interval[0]),
        'MMMM do yyyy - h:mm a',
      ),
    },
  }

  sendMixPanelEvent('Clicked on Multiple Entries', event_data)
}

export async function sendClickedOnEditCalendarEntryEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: calendarStore?.selectedEntry?.type,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
  }

  sendMixPanelEvent('Clicked on Edit Calendar Entry', event_data)
}

export async function sendClickedToActivatePostEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: calendarStore.selectedEntry?.type,
    campaign_reason: calendarStore.selectedEntry.campaign_reason,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    location: 'Calendar Preview',
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Clicked to Activate Post', event_data)
}

export async function sendClickedToActivateMediaEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    campaign_reason: calendarStore.selectedEntry.campaign_reason,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    location: 'Calendar Preview',
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Clicked to Activate Media', event_data)
}

export async function sendShownExpandedCalendarEntryEvent() {
  const calendarStore = useCalendarStore()

  const isMedia =
    calendarStore.selectedEntry?.variant === 'reel' ||
    calendarStore.selectedEntry?.variant === 'story'
  const event_data = {
    entry_type: isMedia ? 'media' : calendarStore.selectedEntry.type,
    object_type: calendarStore.selectedEntry?.object_type,
    //   expanded_type: tasksStore.highlights.length > 1 ? 'multy' : 'single',
    title: calendarStore.selectedEntry?.title,
    campaign_reason: calendarStore.selectedEntry.campaign_reason,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
  }

  sendMixPanelEvent('Shown expanded calendar entry', event_data)
}

export async function sendClickedButtonEvent() {
  const event_data = {
    button_name: 'Create content',
  }

  sendMixPanelEvent('Clicked Button', event_data)
}

export async function sendClickedOnCreateNew(type) {
  const appStore = useAppStore()

  const event_data = {
    date_and_time: format(appStore.date.now(), 'MMMM do yyyy - h:mm a'),
    type,
  }

  sendMixPanelEvent('Clicked on Create New', event_data)
}

export async function sendFacebookErrorEvent(
  type: 'Shown' | 'Clicked',
  location: 'Banner' | 'Opened Entry',
  status,
) {
  const calendarStore = useCalendarStore()

  const accountType = computed(() => {
    return match(calendarStore.spotInfo)
      .with(P.not({ facebook_account_status: 'connected' }), () => 'facebook')
      .with(P.not({ instagram_account_status: 'connected' }), () => 'instagram')
      .otherwise(() => '')
  })

  const event_data = {
    action_name: type,
    alert_location: location,
    status: status,
    type: accountType.value,
  }

  sendMixPanelEvent('Calendar Facebook Error', event_data)
}

export async function sendClickedToDownloadEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    post_type: calendarStore.selectedEntry?.type,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  if ('tracking_properties' in calendarStore.selectedEntry) {
    Object.assign(event_data, calendarStore.selectedEntry.tracking_properties)
  }

  sendMixPanelEvent('Clicked to Download', event_data)
}

export async function sendDownloadButtonDisplayedEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  if ('tracking_properties' in calendarStore.selectedEntry) {
    Object.assign(event_data, calendarStore.selectedEntry.tracking_properties)
  }

  sendMixPanelEvent('Download Button Displayed', event_data)
}

export async function sendClickedButtonInDialogEvent(buttonName) {
  const event_data = {
    button_location: 'Expanded Calendar Entry',
    button_name: buttonName,
  }

  sendMixPanelEvent('Clicked Button', event_data)
}

export async function sendClickedOnPostNowLinkEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    location: 'Expanded Calendar Entry',
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Clicked on Post Now Link', event_data)
}

export async function sendEditedCalendarEntryEvent() {
  const calendarStore = useCalendarStore()

  const diffObject = calendarStore.selectedEntryChangedProperties()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    date_time_edited: Object.hasOwn(diffObject, 'interval'),
    description_edited: Object.hasOwn(diffObject, 'title'),
    captions_edited:
      Object.hasOwn(diffObject, 'title') &&
      calendarStore.selectedCaptionIdea &&
      diffObject?.title?.oldValue !== calendarStore.selectedCaptionIdea?.text
        ? true
        : false,

    captions_generated: calendarStore.selectedCaptionIdea ? true : false,
    photos_edited: Object.hasOwn(diffObject, 'image_url'),
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  if (calendarStore.selectedCaptionIdea) {
    event_data.captions_position =
      calendarStore.captionIdeas.findIndex(
        (e) => e.text === calendarStore.selectedCaptionIdea.text,
      ) + 1
  }

  sendMixPanelEvent('Edited Calendar Entry', event_data)
}

export async function sendPostOriginBannerShownEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    object_type: calendarStore.selectedEntry?.object_type,
  }

  sendMixPanelEvent('Post Origin Banner Shown', event_data)
}

export async function sendPostOriginBannerClickedEvent() {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    object_type: calendarStore.selectedEntry?.object_type,
  }

  sendMixPanelEvent('Post Origin Banner Clicked', event_data)
}

export async function sendInquiriesLinkClickedEvent(
  action: 'Respond' | 'View Details' | 'Delete',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
  }

  sendMixPanelEvent('Inquiries Link Clicked', event_data)
}

export async function sendSocialContentLinkClickedEvent(
  action:
    | 'Additional Post Ideas'
    | 'Add Image to Post'
    | 'Edit Post'
    | 'Post Now'
    | 'Download'
    | 'Delete'
    | 'Approve',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    location: 'Expanded Calendar Entry',
    object_type: calendarStore.selectedEntry?.object_type,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Social Content Link Clicked', event_data)
}

export async function sendEmailContentLinkClickedEvent(
  action: 'Email Now' | 'Approve' | 'Edit' | 'Delete',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    location: 'Expanded Calendar Entry',
    object_type: calendarStore.selectedEntry?.object_type,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    ...(calendarStore.selectedEntry?.tracking_properties ?? {}),
  }

  sendMixPanelEvent('Email Content Link Clicked', event_data)
}

export async function sendReviewContentLinkClickedEvent(action: 'Respond') {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
  }

  sendMixPanelEvent('Review Content Link Clicked', event_data)
}

export async function sendTextContentLinkClickedEvent(
  action: 'Text Now' | 'Edit' | 'Delete' | 'Approve',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
  }

  sendMixPanelEvent('Text Content Link Clicked', event_data)
}

export async function sendWebsiteContentLinkClickedEvent(
  action:
    | 'View on Website'
    | 'Edit'
    | 'Delete'
    | 'Add Photo'
    | 'Clicked on CTA link',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
  }

  sendMixPanelEvent('Website Content Link Clicked', event_data)
}

export async function sendSpecialContentLinkClickedEvent(
  action: 'Edit' | 'Delete' | 'View on Website',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
  }

  sendMixPanelEvent('Special Content Link Clicked', event_data)
}

export async function sendEventContentLinkClickedEvent(
  action: 'Edit' | 'Delete' | 'View on Website',
) {
  const calendarStore = useCalendarStore()

  const event_data = {
    entry_type: getMixpanelEntryType(calendarStore?.selectedEntry),
    action_name: action,
  }

  sendMixPanelEvent('Event Content Link Clicked', event_data)
}

export async function sendShownHolidayNudgeEvent(
  entry: ENTRY_BY_TYPE['holiday_nudge'],
) {
  const event_data = {
    suggested_date: format(
      parseISOWithoutTimezone(entry.interval[0]),
      'MMMM do yyyy',
    ),
    suggested_day: format(parseISOWithoutTimezone(entry.interval[0]), 'E'),
    suggested_hour: format(
      parseISOWithoutTimezone(entry.interval[0]),
      'h:mm a',
    ),
    type: entry.title,
    topic: entry.topic,
    suggested_type: 'marketing_idea',
  }

  sendMixPanelEvent('Shown Suggested Entry', event_data)
}

export async function sendPreviewSuggestedNudgeEvent(
  entry: ENTRY_BY_TYPE['holiday_nudge'] | ENTRY_BY_TYPE['content_nudge'],
) {
  const event_data = {
    suggested_type: entry.variant ?? 'marketing_idea',
    type: entry.variant ? undefined : entry.title,
    topic: entry.variant ? undefined : entry.topic,
    suggested_content: stripHtml(entry.content) ?? entry.title,
  }

  sendMixPanelEvent('Preview Suggested Entry', event_data)
}

export async function sendSuggestedEntryLinkClickedEvent(
  entry: ENTRY_BY_TYPE['holiday_nudge'] | ENTRY_BY_TYPE['content_nudge'],
  additional_data?: Record<string, unknown>,
) {
  const event_data = {
    suggested_type: entry.variant ?? 'marketing_idea',
    type: entry.variant ? undefined : entry.title,
    topic: entry.variant ? undefined : entry.topic,
    suggested_date: format(
      parseISOWithoutTimezone(entry.interval[0]),
      'MMMM do yyyy',
    ),
    suggested_day: format(parseISOWithoutTimezone(entry.interval[0]), 'E'),
    suggested_hour: format(
      parseISOWithoutTimezone(entry.interval[0]),
      'h:mm a',
    ),
    ...additional_data,
  }

  sendMixPanelEvent('Suggested Entry Link Clicked', event_data)
}

type Details = {
  dialog: 'primary' | 'secondary'
  action_name:
    | 'shown'
    | 'clicked_on_switch_to_autopilot'
    | 'clicked_on_keep_approving_first'
}

export async function sendSwitchToAutoPilotPopUpEvent(details: Details) {
  const { dialog, ...rest } = details
  const autopilotDialogStore = useAutopilotDialogStore()

  const name = match(dialog)
    .with('primary', () => 'Switch to Auto-pilot PopUp')
    .with('secondary', () => 'Auto-Pilot Confirmation PopUp')
    .exhaustive()

  const targetGroup = match(autopilotDialogStore.rules)
    .with(
      { neverApproved: true },
      () => 'customers_not_approving_posts' as const,
    )
    .with(
      { stoppedApproving: true },
      () => 'customers_stopped_approving' as const,
    )
    .with({ approving: true }, () => 'customers_approving_posts' as const)
    .otherwise(() => undefined)

  const event_data = {
    target_group: targetGroup,
    ...rest,
  }

  sendMixPanelEvent(name, event_data)
}

//mapper function
export function sendContentLinkEvent(tab: string, type: string) {
  const eventMap: Record<string, () => void> = {
    delete_facebook: () => sendSocialContentLinkClickedEvent('Delete'),
    delete_instagram: () => sendSocialContentLinkClickedEvent('Delete'),
    delete_text: () => sendTextContentLinkClickedEvent('Delete'),
    delete_website: () => sendWebsiteContentLinkClickedEvent('Delete'),
    delete_special: () => sendSpecialContentLinkClickedEvent('Delete'),
    delete_event: () => sendEventContentLinkClickedEvent('Delete'),
    delete_email: () => sendEmailContentLinkClickedEvent('Delete'),
    edit_text: () => sendTextContentLinkClickedEvent('Edit'),
    edit_website: () => sendWebsiteContentLinkClickedEvent('Edit'),
    edit_special: () => sendSpecialContentLinkClickedEvent('Edit'),
    edit_event: () => sendEventContentLinkClickedEvent('Edit'),
    edit_email: () => sendEmailContentLinkClickedEvent('Edit'),
    edit_facebook: () => sendSocialContentLinkClickedEvent('Edit Post'),
    edit_instagram: () => sendSocialContentLinkClickedEvent('Edit Post'),
  }

  const key = `${tab}_${type}`
  if (eventMap[key]) {
    eventMap[key]()
  }
}

export function mediaEditorInfoDisplayedEvent() {
  const calendarStore = useCalendarStore()

  if (
    calendarStore.selectedEntry?.type !== 'facebook' &&
    calendarStore.selectedEntry?.type !== 'instagram'
  )
    return

  const contentType = match(calendarStore.selectedEntry)
    .with(
      { variant: 'post', campaign_reason: P.string.startsWith('flier_') },
      () => 'flyer',
    )
    .with({ variant: 'story' }, () => 'video_story')
    .with({ variant: 'reel' }, () => 'video_reel')
    .otherwise(() => null)

  const allData = {
    ...calendarStore.selectedEntry?.tracking_properties,
    display_type: 'tooltip',
    content_type: contentType,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    template_name: calendarStore.selectedEntry?.content_details?.template_name,
    spothopper_id: calendarStore.selectedEntry?.id,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    colors_used: calendarStore.selectedEntry?.content_details?.colors_used,
    fonts_used: calendarStore.selectedEntry?.content_details?.fonts_used,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Media Editor Info Displayed', allData)
}

export function mediaEditorInfoClickedEvent() {
  const calendarStore = useCalendarStore()
  const allData = {
    ...calendarStore.selectedEntry?.tracking_properties,
    source: 'tooltip',
    spothopper_id: calendarStore.selectedEntry?.id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    template_name: calendarStore.selectedEntry?.content_details?.template_name,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    colors_used: calendarStore.selectedEntry?.content_details?.colors_used,
    fonts_used: calendarStore.selectedEntry?.content_details?.fonts_used,
  }

  sendMixPanelEvent('Media Editor Info Clicked', allData)
}

export function mediaEditorInfoFailedClickedEvent(details: {
  action: 'retry' | 'cancel'
}) {
  const calendarStore = useCalendarStore()
  const action = match(details.action)
    .with('retry', () => 'retried process')
    .with('cancel', () => 'cancelled process')
    .exhaustive()

  const allData = {
    ...calendarStore.selectedEntry?.tracking_properties,
    action,
    spothopper_id: calendarStore.selectedEntry?.id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    template_name: calendarStore.selectedEntry?.content_details?.template_name,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    colors_used: calendarStore.selectedEntry?.content_details?.colors_used,
    fonts_used: calendarStore.selectedEntry?.content_details?.fonts_used,
  }

  sendMixPanelEvent('Media Editor Changes Info Failed Clicked', allData)
}

export function mediaEditorInfoFailedShownEvent(
  trackingProperties: ENTRY_BY_TYPE[
    | 'facebook'
    | 'instagram']['tracking_properties'],
) {
  const calendarStore = useCalendarStore()
  const allData = {
    ...trackingProperties,
    spothopper_id: calendarStore.selectedEntry?.id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    template_name: calendarStore.selectedEntry?.content_details?.template_name,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    colors_used: calendarStore.selectedEntry?.content_details?.colors_used,
    fonts_used: calendarStore.selectedEntry?.content_details?.fonts_used,
  }

  sendMixPanelEvent('Media Editor Changes Info Failed Shown', allData)
}

export function mediaEditorInfoEditedShownEvent(
  trackingProperties: ENTRY_BY_TYPE[
    | 'facebook'
    | 'instagram']['tracking_properties'],
) {
  const calendarStore = useCalendarStore()
  const allData = {
    ...trackingProperties,
    spothopper_id: calendarStore.selectedEntry?.id,
    content_id: calendarStore.selectedEntry?.content_details?.content_id,
    template_id: calendarStore.selectedEntry?.content_details?.template_id,
    template_name: calendarStore.selectedEntry?.content_details?.template_name,
    campaign_reason: calendarStore.selectedEntry?.campaign_reason,
    object_type: calendarStore.selectedEntry?.object_type,
    colors_used: calendarStore.selectedEntry?.content_details?.colors_used,
    fonts_used: calendarStore.selectedEntry?.content_details?.fonts_used,
    template_style:
      calendarStore.selectedEntry?.content_details?.template_style,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Media Editor Changes Saved & Displayed', allData)
}

export function sendPromotionBannerEvent(details: {
  action: 'show' | 'paginate'
  current: number
  total: number
  direction?: 'prev' | 'next'
}) {
  const { action, ...rest } = details

  const name = match(action)
    .with('show', () => 'Next Content Displayed')
    .with('paginate', () => 'Next Content Navigated')
    .exhaustive()

  const direction = match(rest.direction)
    .with('prev', () => 'Previous')
    .with('next', () => 'Next')
    .otherwise(() => null)

  const data = match(action)
    .with('show', () => ({
      position_in_carousel: rest.current + 1,
      total_num_of_content: rest.total,
    }))
    .with('paginate', () => ({
      navigation_direction: direction,
      current_position: rest.current + 1,
      total_num_of_content: rest.total,
    }))
    .exhaustive()

  sendMixPanelEvent(name, data)
}

export function sendMagicRewriteInfoDisplayedEvent() {
  const calendarStore = useCalendarStore()

  const allData = {
    ...calendarStore.selectedEntry?.tracking_properties,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Latest AI Magic Rewrite Info Displayed', allData)
}

export function sendMagicRewriteInfoClosedEvent(action_name: 'closed on X') {
  const calendarStore = useCalendarStore()

  const allData = {
    ...calendarStore.selectedEntry?.tracking_properties,
    action_name,
    template_redesigned_on: calendarStore.selectedEntry?.content_details?.template_redesigned_on ?? ''
  }

  sendMixPanelEvent('Latest AI Rewrite Info Closed', allData)
}
